import type { z } from 'zod'
import { billMoneySchema, type BillBatchActionInput, type billSchema } from '@super-mega/server/contracts/bill'
import { initialIssueEntry, issueEntryPayload, validIssueEntry, type BillIssueEntry } from './bill-issue.ts'

type BatchRows = {
  action: BillBatchActionInput['action']
  bills: z.infer<typeof billSchema>[]
  entries: Partial<Record<number, BillIssueEntry>>
}

export function invalidBatchAmount({ action, bills, entries }: BatchRows) {
  if (action !== 'amount' && action !== 'issue') return null
  const index = bills.findIndex((bill) => {
    const entry = entries[bill.id] ?? initialIssueEntry(bill)
    if (action === 'amount') return bill.status !== 'voided' && !billMoneySchema.safeParse(entry.amount).success
    return bill.status === 'draft' && !validIssueEntry(bill, entry)
  })
  if (index === -1) return null
  let message = `请核对账单 #${bills[index].id} 的用量、单价或金额，免费请填写 0`
  if (action === 'amount') message = `请填写账单 #${bills[index].id} 的修改后金额，免费请填写 0`
  return { index, message }
}

export function batchBillPayload({ action, bills, entries }: BatchRows): BillBatchActionInput['bills'] {
  return bills.map((bill) => {
    const item = { billId: bill.id, expectedUpdatedAt: bill.updatedAt, version: bill.version }
    const entry = entries[bill.id] ?? initialIssueEntry(bill)
    if (action === 'amount') return { ...item, targetAmount: entry.amount ?? '0' }
    if (action === 'issue') return { ...item, ...issueEntryPayload(bill, entry) }
    return item
  })
}

export function billBatchTargetError({
  operation,
  count,
  error
}: {
  operation: { action: string; total?: number }
  count?: number
  error: { message: string } | null
}) {
  const composite = operation.action === 'money' || operation.action === 'group'
  if (composite && (operation.total ?? count ?? 0) > 100) {
    return '创建账单组和登记收款每次最多支持 100 张账单，请缩小搜索范围。'
  }
  return error?.message
}
